import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography,Chip, Checkbox, Table, TableHead, TableBody, TableRow, TableCell, Avatar, TableContainer, Paper, Box
} from '@mui/material';
import { linkAssessmentService, getLinkedAssessmentService } from '../../../services/client.service';
import { TOAST_TYPES } from "../../../utils/constants";
import { toast } from "../../../utils/utils";

const LinkAssessmentDialog = ({assessments, open, onSubmit, loading, onClose, orgName, orgCode, linkedAssessmentCodes = [], linkingLoading = false,}) => {
    const [selectedCodes, setSelectedCodes] = useState([]);

    useEffect(() => {
        if (open) {
            setSelectedCodes([]);
        }
    }, [open]);

    const handleToggle = (code) => {
        setSelectedCodes(prev =>
            prev.includes(code) ? prev.filter(c => c !== code) : [...prev, code]
        );
    };

    const handleSubmit = () => {
        onSubmit(orgCode, selectedCodes);
    };

    const linked = assessments.filter(a => linkedAssessmentCodes.includes(a.code));
    const unlinked = assessments.filter(a => !linkedAssessmentCodes.includes(a.code));

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ color: '#ff6468', fontWeight: 'bold', textAlign: 'center' }}>
                Link Assessments to {orgName}
            </DialogTitle>
            <DialogContent>
                {linkingLoading  ? (
                    <Typography>Loading assessments...</Typography>
                ) : (
                    <>
                        <Typography sx={{ textAlign: 'center', fontSize: '17px', mb: 2 }}>
                            Select the assessment(s) that you would like to link to this client.
                        </Typography>
                        <TableContainer component={Paper} sx={{ mt: 2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Assessment Name</TableCell>
                                        <TableCell>Questions</TableCell>
                                        <TableCell>Time (min)</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {[...linked, ...unlinked].map((a) => (
                                        <TableRow
                                            key={a.code || a.id}
                                            sx={{
                                                backgroundColor: linkedAssessmentCodes.includes(a.code) ? '#fbe9e7' : 'inherit'
                                            }}
                                        >
                                            <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Avatar
                                                    src={a.image_url}
                                                    variant="rounded"
                                                    sx={{ width: 56, height: 56, border: '1.5px solid #ff6468' }}
                                                />
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 500,
                                                            lineHeight: '1.5',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginLeft:'15px',
                                                        }}
                                                    >
                                                        {a.full_name}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell>{a.length_questions}</TableCell>
                                            <TableCell>{a.time_to_complete_minutes}</TableCell>
                                            <TableCell align="center">
                                                {linkedAssessmentCodes.includes(a.code) ? (
                                                    <Chip
                                                        label="Already Linked"
                                                        size="small"
                                                        sx={{
                                                            backgroundColor:'transparent',
                                                            color: '#0097a7',
                                                            fontWeight: 'bold'
                                                        }}
                                                    />
                                                ) : (
                                                    <Checkbox
                                                        checked={selectedCodes.includes(a.code)}
                                                        onChange={() => handleToggle(a.code)}
                                                        sx={{color: '#ff6468',
                                                            '&.Mui-checked': {
                                                                color: '#ff6468',
                                                            },
                                                        }}
                                                    />
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Box sx={{ display: 'flex', width: '100%',alignItems:'center', justifyContent: 'center', gap: 2, mb: 3 }}>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    sx={{
                        borderRadius: '20px',
                        minWidth: '120px',
                        fontWeight: 'bold',
                        borderColor: '#0097b2',
                        color: '#0097b2',
                    }}
                    disabled={loading}
                >
                    Cancel
                </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={loading || selectedCodes.length === 0}
                        sx={{ backgroundColor: '#ff6468', borderRadius: '20px', minWidth: 120 }}
                    >
                        {loading ? 'Linking...' : 'Submit'}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default LinkAssessmentDialog;